import { LoggingPropertyConfiguration } from '../models/logging-property-configuration';
import { inject, Injectable } from '@angular/core';
import { InitProperties } from '../models/init-properties';
import { AmplitudeHandler, DatadogHandler, IntercomHandler } from '../handlers';
import { BaseLogging } from '@rx-applications/shared/logging';

@Injectable({
  providedIn: 'root',
})
export class ClientsiteSharedLoggingService extends BaseLogging<InitProperties, LoggingPropertyConfiguration> {
  #amplitudeHandler = inject(AmplitudeHandler);
  #datadogHandler = inject(DatadogHandler);
  #intercomHandler = inject(IntercomHandler);

  init(initProperties: InitProperties) {
    this.#amplitudeHandler.init(initProperties);
    this.#datadogHandler.init(initProperties);
    this.#intercomHandler.init(initProperties);
  }

  createSetup(loggingPropertyConfiguration: LoggingPropertyConfiguration): void {
    this.#amplitudeHandler.createSetup(loggingPropertyConfiguration);
    this.#datadogHandler.createSetup(loggingPropertyConfiguration);
    this.#intercomHandler.createSetup(loggingPropertyConfiguration);
  }
}
